/**
 * 積卸地設定ページ用のスクリプト
 */
 if (is_route('delivery_item.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        delivery_item_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.delivery_item_event_set = function() {

    let csvSettingModalId = '#delivery_item-csv-setting-modal';
    let csvFormId = csvSettingModalId + '-form';

    /*---- CSVダウンロード時 ----*/

    // CSVダウンロード時
    $(document).on('click', '#search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // ポスト送信を実行
        post(action, datas);
    });

    /*---- CSVアップロード表示時 ----*/

    // CSVアップロード表示時
    $(document).on('click', '#search-form-action_upload', function () {
        // 初期化処理
        $(csvSettingModalId + '-csv-submit-message').addClass('display-none').empty();
        $(csvSettingModalId + '-csv-error').addClass('display-none').empty();
        $(csvSettingModalId + 'csv').val('');
    });

    /*---- CSVアップロード確認時 ----*/

    // CSVアップロード確認時
    $(document).on('change', csvSettingModalId + '-csv', function () {
        let csvFormId = csvSettingModalId + '-form';
        let action = $(csvFormId).data('confirm-action');
        let datas = new FormData($(csvFormId).get(0));
        $(csvSettingModalId + '-csv-error').addClass('display-none').empty();
        $(csvSettingModalId + '-csv-submit-message').addClass('display-none').empty();;
        $("[data-csv-save-modal]").prop('disabled', true);
        // 送信
        _ajax.file(action, datas, function (results) {
            $(csvSettingModalId + '-csv-submit-message').removeClass('display-none');
            $(csvSettingModalId + '-csv-submit-message').text(results.messages[0]);
            $("[data-csv-save-modal]").prop("disabled", false);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
            $(this).val('');
            // フォームにエラーメッセージを配置
            $.each(xhr.responseJSON.errors, function(name, message) {
                $(csvSettingModalId + '-csv-error').removeClass('display-none');
                $(csvSettingModalId + '-csv-error').append($('<li></li>').text(message));
            });
        });
    });

    /*---- CSVアップロード時 ----*/

    // 設定表示時
    $(document).on('click', '[data-csv-save-modal]', function () {
        let action = $(csvFormId).attr('action');
        let datas = new FormData($(csvFormId).get(0));
        // 送信前にエラーをリセット
        _error.reset()
        // 送信
        _ajax.file(action, datas, function (results) {
            // 完了メッセージをセットする
            _complete.set(results);
            // モーダルを閉じる
            _modal.hide(csvSettingModalId);
            // コンテンツの読込
            load_contents();
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /*---- 品目 ----*/
    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], true);
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        // select2の初期化が出来ていない場合は値を入れる
        let deliveryItemForm = $(deliveryItemSettingModalId).find('form');
        let UnitSelect = deliveryItemForm.find('[name="unit_id"]');
        let categorySelect = deliveryItemForm.find('[name="category_id"]');
        if (UnitSelect.val() === '' || UnitSelect.val() === null) {
            UnitSelect.val(null).trigger('change');
        }
        if (categorySelect.val() === '' || categorySelect.val() === null) {
            categorySelect.val(null).trigger('change');
        }
        _modal.submit(this, 'save-modal');
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

    /*---- カテゴリ・単位マスタ ----*/

    let deliveryItemSettingModalId = '#delivery_item-setting-modal';
    let categoryListModalId = '#delivery_item-category-list-modal';
    let unitListModalId = '#delivery_item-unit-list-modal';

    // コールバック
    let delivery_list_callback = function(results) {
        // 不要なモーダルを閉じる
        let removeModals = $('.modal').not(deliveryItemSettingModalId);
        $.each(removeModals, function (index, modal) {
            _modal.hide(create_id(modal.id));
        });

        // select2に登録レコードを反映し、選択状態とする
        let deliveryItemForm = $(deliveryItemSettingModalId).find('form');
        let holdingSelect = deliveryItemForm.find('[name="holding_id"]');
        let companySelect = deliveryItemForm.find('[name="company_id"]');
        let type = results.unit ? 'unit' : 'category';
        let isDelete = false;
        if (!results.unit && !results.category) {
            type = results.type;
            isDelete = true;
        }
        let select = deliveryItemForm.find('[name="' + type + '_id"]');

        // 削除後の呼び出し
        if (isDelete) {
            select.val(null).trigger('change');
            holdingSelect.trigger('change');
            return;
        }

        if ((holdingSelect.val() !== '' && holdingSelect.val() !== results[type].holding_id)
            || (companySelect.val() !== '' && companySelect.val() !== results[type].company_id)) {
            // 編集中の品目と、追加したカテゴリ・単位の所属が異なれば、何もしない
            return;
        }

        // 更新後の呼び出し
        if (select.find('option[value="' + results[type].id + '"]').length > 0) {
            holdingSelect.trigger('change');
            return;
        }

        // 新規追加後の呼び出し
        let newOption = new Option(results[type].content1, results[type].id, true, true);
        select.append(newOption).trigger('change');
    };

    // カテゴリ・単位 マスタ画面表示（リスト）
    $(document).on('click', '[data-category-list-modal], [data-unit-list-modal]', function () {
        let type = getTypeCategoryOrUnit($(this));
        let deliveryItemForm = $(deliveryItemSettingModalId).find('form');
        let serializeArray = deliveryItemForm.serializeArray();
        setDataFormValues(serializeArray, $(this), ['holding_id', 'company_id']);

        // 所属を絞り込んで表示
        _modal.create(this, type + '-list-modal', [
            'holding_id', 'company_id', 'page'
        ], false);
    });

    // カテゴリ・単位 マスタ画面表示（リスト）一覧所属変更時
    let listSelect2Elements = [
        categoryListModalId + '-holding_id:enabled', categoryListModalId + '-company_id:enabled',
        unitListModalId + '-holding_id:enabled', unitListModalId + '-company_id:enabled',
    ];
    $(document).on('select2:select', listSelect2Elements.join(','), function() {
        let form = $(this).parents('form');
        let dates = form.serializeArray();
        let action = form.attr('action');
        let modalId = form.data('modal_id');
        _modal.update(modalId, action, dates, true);
    });

    // カテゴリ・単位 設定画面表示
    $(document).on('click', '[data-category-setting-modal], [data-unit-setting-modal]', function (e) {
        let type = getTypeCategoryOrUnit($(this));
        let form = $('#delivery_item-' + type + '-list-modal').find('form');
        let serializeArray = form.serializeArray();
        setDataFormValues(serializeArray, $(this), ['holding_id', 'company_id']);

        // 所属を絞り込んで表示
        _modal.create(this, type + '-setting-modal', [
            'holding_id', 'company_id', 'id'
        ], true);
    });

    // カテゴリ・単位  設定保存
    $(document).on('click', '[data-category-save-modal], [data-unit-save-modal]', function () {
        let type = getTypeCategoryOrUnit($(this));
        _modal.submit(this, type+ '-save-modal', delivery_list_callback, null, '-form', true);
    });

    // カテゴリ・単位 削除確認画面表示
    $(document).on('click', '[data-category-confirm-modal], [data-unit-confirm-modal]', function () {
        let type = getTypeCategoryOrUnit($(this));
        _modal.create(this, type + '-confirm-modal', ['id']);
    });

    // カテゴリ・単位 削除実行
    $(document).on('click', '[data-category-delete-modal], [data-unit-delete-modal]', function () {
        let type = getTypeCategoryOrUnit($(this));
        _modal.submit(this, type + '-delete-modal', delivery_list_callback, null, '-form', true);
    });

    // data属性に値を設定
    function setDataFormValues(serializeArray, toModalElement, keys = []) {
        $.each(serializeArray, function (index, item) {
            let name = item.name;
            // name属性が同じフォームが存在すれば、値を設定
            if (keys.includes(name)) {
                // data属性追加（modalで引き継ぐ用）
                toModalElement.data(name, item.value);
                // form要素設定
                toModalElement.find('[name="'+name+'"]').val(item.value).trigger('change');
            }
        })
    }

    // カテゴリor単位 どちらを操作中か取得
    function getTypeCategoryOrUnit(elem) {
        // データ属性のみ取得
        let data = elem.data();
        // キーのみ取得
        let keyArray = Object.keys(data);
        let isCategory = true;
        keyArray.forEach(function (key) {
            // unitを含むか
            if (key.indexOf('unit') > -1) {
                isCategory = false;
            }
        });
        return isCategory ? 'category' : 'unit';
    }
}
